import { ActionTree } from 'vuex';
import { PostgradStudentDocumentsState } from './state';
import RootState from '@/store/root_state';
import StudentDocumentRequestService from '@/helpers/postgradStudentDocuments/request';
import { getChimeraToken } from '@/helpers/get-tokens';
import { CourseModel } from '@descomplica/dex-models';
import { parseFileToBase64, parseFileToBlob } from '@/helpers/file';

const parsePdfToObjectURL = async (url: string): Promise<string> => {
  const data = await parseFileToBlob({ fileUrl: url });

  return data ? URL.createObjectURL(data) : '';
};

const actions: ActionTree<PostgradStudentDocumentsState, RootState> = {
  async GET_USER_DOCUMENTS_STATUS_BY_COURSE_ID({ commit }, course: CourseModel) {
    const descomplicaToken = getChimeraToken();

    if (!course.descomplicaCourseId) return;

    const documentsStatus = await StudentDocumentRequestService.getStudentDocumentsStatus(
      descomplicaToken,
      course,
    );

    commit('SET_POSTGRAD_STUDENT_DOCUMENTS_STATUS', {
      documentsStatus,
      courseId: course.id,
    });
  },

  async GET_USER_CERTIFICATE_INFO_BY_COURSE_ID({ commit }, course: CourseModel) {
    const descomplicaToken = getChimeraToken();

    if (!course.descomplicaCourseId) return;

    const certificateInfo = await StudentDocumentRequestService.getCertificateInfo(
      descomplicaToken,
      course,
    );

    if (!certificateInfo) return;

    const [pdfBase64, socialVersionBase64, ...originalVersionBase64s] = await Promise.all([
      parsePdfToObjectURL(certificateInfo.originalVersionPdfUrl),
      parseFileToBase64({ fileUrl: certificateInfo.socialVersionImageUrl }),
      ...certificateInfo.originalVersionImageUrls.map((imageUrl) =>
        parseFileToBase64({ fileUrl: imageUrl }),
      ),
    ]);

    certificateInfo.originalVersionPdfUrl = pdfBase64 as string;
    certificateInfo.originalVersionImageUrls = originalVersionBase64s;
    certificateInfo.socialVersionImageUrl = socialVersionBase64;

    commit('SET_POSTGRAD_STUDENT_CERTIFICATE_INFO', {
      ...certificateInfo,
      courseId: course.id,
    });
  },
};

export default actions;
